import { AnalyticsReport, ReportingViewState } from 'store/analytics/ui/analyticsUiTypes';
import {
  DateRange,
  FixedTimeRange,
} from 'views/Analytics/AnalyticsMockService/Reporting/Pickers/BzmDateRangePicker/BzmDateRangePicker';
import { MetricResolution } from 'types/rest/analyticsTypes';

export const SELECT_REPORT = 'SELECT_REPORT';
export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const SET_RESOLUTION = 'SET_RESOLUTION';
export const SET_FIXED_TIME_RANGE = 'SET_FIXED_TIME_RANGE';
export const SET_REPORT_CONFIG = 'SET_REPORT_CONFIG';
export const SELECT_MOCK_SERVICES = 'SELECT_MOCK_SERVICES';
export const SET_MS_SEARCH_KEYWORD = 'SET_MS_SEARCH_KEYWORD';

export type SelectReport = {
  type: typeof SELECT_REPORT;
  payload: AnalyticsReport;
};

export type SetDateRange = {
  type: typeof SET_DATE_RANGE;
  payload: DateRange;
};

export type SetResolution = {
  type: typeof SET_RESOLUTION;
  payload: MetricResolution;
};

export type SetFixedTimeRange = {
  type: typeof SET_FIXED_TIME_RANGE;
  payload: FixedTimeRange | null;
};

export type SetReportConfig = {
  type: typeof SET_REPORT_CONFIG;
  payload: ReportingViewState | null;
};

export type SelectMockServices = {
  type: typeof SELECT_MOCK_SERVICES;
  payload: number[];
};

export type SetMsSearchKeyword = {
  type: typeof SET_MS_SEARCH_KEYWORD;
  payload: string;
};

export type ReportingViewActionTypes =
  | SelectReport
  | SetFixedTimeRange
  | SetResolution
  | SetDateRange
  | SetReportConfig
  | SetMsSearchKeyword
  | SelectMockServices;
